
<template>
<v-app>
  <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>
    <section id="main-cabecera" class="mb-4">
     <v-card  color="#393E46">
       <v-card-title><h1 class="display-2 font-weight-bold mb-3">
         Términos y Condiciones
       </h1></v-card-title>
       <v-card-subtitle>
         EL PRESENTE TICKET/QR ES VENDIDO Y/O OTORGADO POR DO NEGOCIOS SAC (“TUNAY”) POR ENCARGO Y DE ACUERDO A LAS CONDICIONES INDICADAS POR LA EMPRESA ORGANIZADORA DEL EVENTO (EL “ORGANIZADOR”). ATENDIENDO A ELLO, LA ADQUISICIÓN / OBTENCIÓN DE ESTE TICKET SUPONE LA ACEPTACIÓN DE LAS SIGUIENTES CONDICIONES:
       </v-card-subtitle>
       <v-card-text>
       <v-row >

    <v-col cols="12" sm="12" md="12" lg="12">
    <h3 class="">
      Condiciones Generales:
    </h3>
      <br/>
      <ul>
        <li>
          Tunay únicamente opera como un punto de venta u operador de las entradas/QR del evento, por lo tanto, no se encarga ni es responsable por la organización del mismo.
        </li>
        <li>
          Tunay no es responsable por el aplazamiento o cancelación del evento, así como por cualquier hecho que ocurra antes, durante o con posterioridad a la celebración del mismo.
        </li>
        <li>
          Si la fecha u hora del evento fuera modificada, siempre que medie indicación del Organizador, el presente Ticket/QR será válido para ser utilizada en la fecha u hora definitiva que fije el Organizador.
        </li>
        <li>
          Tunay no se hace responsable por Tickets/QRs adquiridos/obtenidos en puntos de venta no oficiales. En caso estos sean falsos o adulterados, no se permitirá el ingreso al evento.
        </li>
        <li>
          Al adquirir u obtener un Ticket/QRs estas aceptando no divulgarlo, ni compartirlo con terceros, ya que esto podría afectar tu ingreso al evento.
        </li>
        <li>
          Al comprar u obtener tu Ticket/QR, comprueba que el espectáculo, evento, fecha, horario, situación y precio sean los correctos, pues no se aceptarán cambios, devoluciones o reintegros de los Tickets/QR adquiridos, con excepción de Cancelación de Evento, en cuyo caso se indicará el procedimiento a seguir según indicaciones del Organizador.</li>
        <li>
          Para ingresar al evento deberá portar su Ticket/QR, virtual o impreso, según sea el caso, a efectos de cumplir con la verificación correspondiente.
        </li>
        <li>
          El día del evento, al ingresar al establecimiento, el público podrá estar sujeto a verificaciones adicionales por razones de seguridad, de acuerdo a lo establecido por el Organizador. Ante la negativa a cumplir con alguna de las verificaciones requeridas, no se le permitirá el ingreso al evento.
        </li>
        <li>
          El ingreso después de la hora señalada en la entrada está sujeto a las reglas del Organizador y del establecimiento donde se llevará a cabo el evento.
        </li>
        <li>
          Tunay no tiene injerencia en la determinación de las condiciones de seguridad del establecimiento, las que serán de exclusiva responsabilidad del Organizador. Asimismo, el Organizador podrá (i) reservarse el derecho de prohibirle al público filmar o grabar este evento, y (ii) restringir el ingreso de grabadoras, filmadoras, máquinas fotográficas, latas, botellas, armas o cualquier objeto que el Organizador consideren peligroso
        </li>
      </ul>
      <br/>
      <h3 class="">
        Procedimiento para desafiliar o dar de baja el usuario de la cuenta Tunay:
      </h3>
      <br/>
      <ul>
        <li>
          Enviar un correo a info@tunay.app indicando “BAJA DE USUARIO” como Asunto
        </li>
        <li>
          Para validar titularidad de la cuenta, el mail deberá ser enviado desde la misma cuenta de correo que se solicita dar de baja.
        </li>
        <li>
          La cuenta Tunay queda inactiva para uso luego de un plazo máximo de 15 días calendario.
        </li>
        <li>
          El cliente recibirá correo de confirmación de baja de usuario.
        </li>
      </ul>
         </v-col>
       </v-row>
       </v-card-text> </v-card> </section>


  </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>

<script>

import cabecera from '../general/cabecera';
import piepagina from '../general/piepagina';
import Cabecerabaja from "@/components/general/cabecerabaja";
  export default {
    name: 'politicas',
    components: {
      Cabecerabaja,
    cabecera,
    piepagina,
  },
    data () {
      return {
        clientesimg: [],
        email: '',
        emailRules: [
          v => !!v || 'Se necesita el Email',
          v => /.+@.+/.test(v) || 'E-mail debe ser valido',
        ]
          }
    },

  }
</script>
